import gql from 'graphql-tag';

export const getIBeacons = gql`
  query ($application: Int) {
    getIBeaconsWithIoT(application: $application, active: true) {
      deviceId
      application {
        applicationId
      }
      name
      model {
        modelId
        name
        remark
      }
      serial
      mac
      region
      longitude
      latitude
      distance
      remark
      optional
      date
      uuid
      major
      minor
      title
      text
      battery
      live
      humidity
      temperature
      txPower
      advInt
      x
      y
      z
      tags
      deploymentDate
    }
  }
`

export const getIBeaconsByParams = gql`
  query ($uuid: String, $major: Int, $minor: Int) {
    getIBeacons(uuid: $uuid, major: $major, minor: $minor, active: true) {
      deviceId
      uuid
      major
      minor
    }
  }
`

export const getInventoryIBeacons = gql`
  query {
    getIBeacons(application: null) {
      deviceId
      application {
        applicationId
      }
      name
      model {
        modelId
        name
        remark
      }
      serial
      mac
      region
      longitude
      latitude
      distance
      remark
      optional
      date
      uuid
      major
      minor
      battery
      title
      text
      battery
      live
      humidity
      temperature
      txPower
      advInt
      x
      y
      z
      deploymentDate
    }
  }
`
